module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/arrow-down-circle--hover-05fd289b209cc8d18e65ebb2643c45f2.png";